import React, { useState } from 'react';
import { RecaptchaVerifier } from 'firebase/auth';
import toast from 'react-hot-toast';
import PhoneInput from 'react-phone-number-input';
import { E164Number } from 'libphonenumber-js';
import { useTranslation } from 'react-i18next';
import OtpStep from './OtpStep';
import ResetPasswordStep from './ResetPasswordStep';
import { API_URL } from '../../utils/data';
import { Circles } from 'react-loader-spinner';
import { AppDispatch, RootState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import { useSEO } from '../../custom hooks/useSEO';
import { sendOTP } from '../../features/auth/registerSlice';

declare global {
  interface Window {
    recaptchaVerifier: RecaptchaVerifier;
    confirmationResult: any;
  }
}

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { t: tSeo } = useTranslation("seo");

  const seo = useSEO({
    title: tSeo("forgetPassword.title"),
    description: tSeo("forgetPassword.description")
  });
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState<E164Number | undefined>();
  const [error, setError] = useState('');
  const dispatch = useDispatch<AppDispatch>();
  const { loading } = useSelector((state: RootState) => state.register);

  const handleSendOTP = async () => {
    setError('');
    try {
      const phone = encodeURIComponent(String(phoneNumber));
      const response = await fetch(`${API_URL}Authentication/sendOTP?isLogin=true&&phone=${phone}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.message || 'فشل في إرسال الكود');
        return;
      }

      toast.success(t('otp-sent'));
      setStep(2);
    } catch (error: any) {
      console.error('Error sending OTP:', error);
      setError(`Error sending OTP: ${error.message}`);
    }
  };
  const handleResend = async () => {
    if (phoneNumber) {
    await dispatch(sendOTP(phoneNumber));
    }
  };


  return (
    <div className='main-prop'>
      {seo}
      {step === 1 && (
        <div>
          <h2 className='text-2xl font-semibold mb-3'>{t("reset-password")}</h2>
          <label className='text-lg font-medium mb-1'>{t("number")}</label>
          <PhoneInput
            international
            defaultCountry="LY"
            value={phoneNumber}
            onChange={setPhoneNumber}
            className="phone-input border w-full p-3 rounded-lg bg-white"
          />

          <div className='w-full bg-secondry rounded-lg py-3 mt-5 text-white cursor-pointer flex items-center justify-center'>
            {loading ? <Circles
              height="20"
              width="20"
              color="#fff"
              ariaLabel="circles-loading"
              visible={true}
            /> : <button onClick={handleSendOTP} value={t("register")} className='w-full cursor-pointer' >{t("next")}</button>}
          </div>
          {error && <p className='text-red-500 text-sm mt-2'>{error}</p>}
          <div id='recaptcha-container'></div>
        </div>
      )}

      {step === 2 && (
        <OtpStep
          phone={String(phoneNumber)}
          onVerified={() => setStep(3)}
          onResend={handleResend}
        />
      )}

      {step === 3 && (
        <ResetPasswordStep phone={phoneNumber as string} />
      )}
    </div>
  );
};

export default ForgotPassword;
